__turbopack_context__.v({
  "contentWrapper": "TemplateShareModal-module__kzFp1q__contentWrapper",
  "footer": "TemplateShareModal-module__kzFp1q__footer",
  "intro": "TemplateShareModal-module__kzFp1q__intro",
  "title": "TemplateShareModal-module__kzFp1q__title",
});
